import { Input, Modal, Space, Spin } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import { AlertTextBold } from 'components/UIComponents/FormStyles'
import EmptyCandidateIcon from 'components/icons/EmptyCandidateIcon'
import { EmptyWrapper } from 'modules/Drives/Components/Styles/style'
import { FooterFlex } from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/style'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { EmptyElement } from '../../../../../components/UIComponents/CommonStyledDiv'
import { PassingScoreHeader, StyledAlert, StyledTable } from './style'

const ExternalTextArea = styled(Input)`
  background-color: #fafafb;
  border: 0.7px solid #d9d9d9;
  padding: 0px 4px 0px 4px;
  gap: 3px;
  width: 112px;
  height: 30px;

  &::placeholder {
    font-weight: 500;
    font-size: 12px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    line-height: 20px;
  }

  .ant-input-prefix {
    margin-right: 4px;
    font-size: larger;
    font-weight: 500;
  }
`

const TestGorillaDrawer = ({
  testGorillaDrawer,
  setTestGorillaDrawer,
  loading,
  topicList,
  postPassingScore,
  getCandidateScore,
  setTopicList,
  getTopicsList,
  assessmentId,
  setTopicsData,
}) => {
  const [data, setData] = useState(topicList)
  const [inputValue, setInputValue] = useState(false)

  function isValidNumber(value) {
    return !isNaN(value)
  }

  useEffect(() => {
    setData(topicList)
  }, [topicList])
  const onChangeScore = (a, b, c, d) => {
    const updatedData = data.map((item, index) => {
      if (index === c) {
        return { ...item, passingScore: a }
      }
      return item
    })

    const isValid = updatedData.find(item => Number(item.passingScore) > 100)
    const validData = updatedData?.map(item => item.passingScore)
    const isDataValid = validData?.filter(item => {
      return (
        item !== null &&
        item !== '' &&
        !/^-?(?:\d*\.?\d+|\.\d+)(?:e-?\d+)?$/.test(item)
      )
    })

    if (typeof isValid === 'object' || isDataValid?.length > 0) {
      setInputValue(true)
    } else {
      setInputValue(false)
    }
    setData(updatedData)
  }
  const onResetClick = async e => {
    const updatedData = data.map(item => {
      return { ...item, passingScore: 0 }
    })

    e.preventDefault()
    let response = await postPassingScore(updatedData)

    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('Score Updated Successfully')
      setTestGorillaDrawer(false)
      getCandidateScore()
      let data = await getTopicsList(assessmentId)

      if (data?.status >= 200 && data?.status <= 300) {
        setTopicList(data?.data?.data || [])
        setTopicsData(response?.data?.data || [])
      }
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const columns = [
    {
      title: 'Tests',
      dataIndex: 'name',
      width: '70%',
      render: (id, record) => <div>{record?.name || '-'}</div>,
    },
    {
      title: 'Passing Score',
      dataIndex: 'passingScore',
      width: '30%',
      render: (text, record, index) => (
        <Space size="small">
          <div>
            <ExternalTextArea
              placeholder="Exp:40"
              prefix="&#8805;"
              value={record?.passingScore}
              onChange={e =>
                onChangeScore(e.target.value, record.id, index, text)
              }
            />
            <br />
            {record?.passingScore ? (
              !isValidNumber(record?.passingScore) ? (
                <span
                  style={{ display: 'flex', color: 'red' }}
                  className="error_text_for_number"
                >
                  {' '}
                  Kindly enter a number
                </span>
              ) : (isValidNumber(record?.passingScore) &&
                  Number(record?.passingScore) > 100) ||
                (isValidNumber(record?.passingScore) &&
                  Number(record?.passingScore) < 0) ? (
                <span
                  style={{ display: 'flex', color: 'red' }}
                  className="error_text_for_number"
                >
                  {' '}
                  Kindly enter a valid number
                </span>
              ) : (
                ''
              )
            ) : (
              ''
            )}
          </div>
        </Space>
      ),
    },
  ]

  const onClose = async e => {
    e.preventDefault()
    let response = await postPassingScore(topicList)

    if (response?.status >= 200 && response?.status <= 300) {
      setTestGorillaDrawer(false)
      getCandidateScore()
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }
  const errorClass = document?.getElementsByClassName('error_text_for_number')
  const checkValidation = () => {
    if (!errorClass || errorClass.length === 0) {
      return true
    }

    for (const element of errorClass) {
      if (element?.innerHTML?.trim() !== '') {
        return false
      }
    }
    return true
  }

  const onClickSet = async e => {
    const valid = checkValidation()
    e.preventDefault()
    const updatedData = data.map(item => {
      return {
        ...item,
        passingScore: item?.passingScore ? item?.passingScore : 0,
      }
    })
    if (valid) {
      let response = await postPassingScore(updatedData)
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage('Score Updated Successfully')
        setTestGorillaDrawer(false)
        getCandidateScore()
        let data = await getTopicsList(assessmentId)

        if (data?.status >= 200 && data?.status <= 300) {
          setTopicList(data?.data?.data || [])
          setTopicsData(response?.data?.data || [])
        }
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    }
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd centerVertically>
        <EmptyElement
          onClick={onResetClick}
          style={{ color: 'red', marginRight: '479px', cursor: 'pointer' }}
        >
          Reset
        </EmptyElement>
        <Button.Secondary width="88px" text="Cancel" onClick={onClose} />
        <Button.Primary
          disabled={inputValue}
          width="110px"
          text="Set"
          loading={loading}
          onClick={onClickSet}
          type="submit"
        />
      </FooterFlex>
    )
  }

  return (
    <div>
      <Modal
        open={testGorillaDrawer}
        centered // This prop centers the modal vertically and horizontally
        footer={footer()}
        maskClosable={false} // Prevent closing the modal when clicking outside
        closable={false} // Hide the close button
        bodyStyle={{
          borderRadius: '10px',
          padding: '20px',
          textAlign: 'center',
          gap: '10px',
        }}
        width={800}
      >
        <div>
          <PassingScoreHeader>Set Qualifying Score</PassingScoreHeader>
          <StyledAlert
            message={
              <AlertTextBold style={{ background: '#F3F5FF' }}>
                <b> Note:</b> &nbsp; Prioritize the tests that are most
                important to you by assigning them a passing score.The weight of
                a test directly impacts your Candidate Shortlist.
              </AlertTextBold>
            }
            type="info"
            marginbottom={'25px'}
            margintop={'10px'}
          />
        </div>
        <StyledTable
          rowSelection={false}
          rowKey={record => record?.id}
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{
            y: 360,
          }}
          locale={{
            emptyText: (
              <EmptyWrapper column alignCenter isSpin={loading}>
                {!loading ? (
                  <Flex column alignCenter>
                    <centerText>
                      <EmptyCandidateIcon />
                    </centerText>
                    <centerText>
                      <centerText>
                        No candidates found in this Passing Score
                      </centerText>
                    </centerText>
                  </Flex>
                ) : (
                  <Spin />
                )}
              </EmptyWrapper>
            ),
          }}
        />
      </Modal>
    </div>
  )
}

export default TestGorillaDrawer
